module.exports = __webpack_public_path__ + "img/fig9.14.ffd4671e.png";